import { unsafeCSS } from 'lit';
export function isSafari() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('safari') && !ua.includes('chrome') && !ua.includes('crios');
}
export function isStandalone() {
    return window?.navigator?.standalone ?? false;
}
export function safariPWACss(style) {
    if (isSafari() && isStandalone()) {
        return unsafeCSS(style);
    }
    return unsafeCSS('');
}
//# sourceMappingURL=platform.js.map